export enum TrainingStatus {
  Complete = 'Completed',
  Due = 'Training Due',
  PastDue = 'Past Due',
  Inactive = 'Inactive',
}
